import AppError from './models/common/res/AppError';
import { request, Rows } from './request';
import { Nation } from './models/nation/res/Nation';

export const fetchNations = async () => {
  const url = '/meta-data/nations';
  try {
    const { data } = await request<Rows<Nation>>({
      method: 'get',
      url,
    });
    const { rows } = data;
    return rows;
  } catch (e) {
    throw new AppError(e);
  }
};
